// globals/helpers/sessionLogout.ts
import router from "@/router";
import pinia from "@/plugins/piniaStore";
import { userTokenStore } from "@/stores/tokenStore";
import { useAccountDataUser } from "@/modules/5.account/stores/accountDataStore";
import { piniaStorageDB } from "@/persistentStorage/piniaStorageDB";

export async function sessionLogout() {
  const token = userTokenStore(pinia);
  const account = useAccountDataUser(pinia);

  token.clearToken("");
  await piniaStorageDB.clearToken(); // novo: remover o token persistido

  // Manter só o email, e só se o utilizador pediu para ser lembrado.
  const keepEmail = account.rememberMe ? account.email : "";
  account.$reset();
  account.$state.email = keepEmail;
  account.$state.rememberMe = !!keepEmail;
  await piniaStorageDB.saveUserDataAccount();

  // Repor as stores com dados do utilizador anterior (dropdown, rodapé,
  // cabeçalho, fichas, respostas, filtros). Confirmar a lista na aplicação.

  await router.replace("/login");
}

/* OLD 22.set.2026 jirodrig
import router from "@/router";
import { userTokenStore } from "@/stores/tokenStore";
import pinia from "@/plugins/piniaStore";

export function sessionLogout() {
  //const tokenStore = userTokenStore(pinia);
  //tokenStore.clearToken("sessionLogout");
  router.replace("/login");
}

export function sessionEndPage() {
  router.replace("/endApp");
}
*/

/** Sessão expirada (refresh falhou): limpar credenciais e mostrar a página de fim. */
export async function sessionEndPage() {
  const token = userTokenStore(pinia);
  token.clearToken("");
  await piniaStorageDB.clearToken();
  await router.replace("/endApp");
}
